import React, { createContext, useContext, useState, useEffect } from 'react';

const ThemeContext = createContext({
  isDark: true,
  toggleTheme: () => {},
});

export const useTheme = () => useContext(ThemeContext);

export function ThemeProvider({ children }) {
  const [isDark, setIsDark] = useState(() => {
    try {
      const stored = localStorage.getItem('pm_theme');
      return stored ? stored === 'dark' : true;
    } catch { return true; }
  });

  useEffect(() => {
    document.documentElement.classList.toggle('light-theme', !isDark);
    try { localStorage.setItem('pm_theme', isDark ? 'dark' : 'light'); } catch {}
  }, [isDark]);

  const toggleTheme = () => setIsDark(prev => !prev);

  return (
    <ThemeContext.Provider value={{ isDark, toggleTheme }}>
      {children}
    </ThemeContext.Provider>
  );
}

const ModeContext = createContext({
  animeMode: false,
  setAnimeMode: () => {},
});

export const useMode = () => useContext(ModeContext);

export function ModeProvider({ children }) {
  const [animeMode, setAnimeMode] = useState(false);

  return (
    <ModeContext.Provider value={{ animeMode, setAnimeMode }}>
      {children}
    </ModeContext.Provider>
  );
}
